import { 
    QUANTUM_OVERVIEW_FETCHED, 
    QUANTUM_DETAILS_FETCHED, 
    QUANTUM_GRAPH_DATA_FETCHED, 
    QUANTUM_DOWNLOAD_START,
    QUANTUM_DOWNLOAD_SUCCESS,
    QUANTUM_DOWNLOAD_ERROR,
    QUANTUM_TOKEN_GENERATING,
    QUANTUM_TOKEN_GENERATED,
    QUANTUM_TOKEN_ERROR
} from "../actions";

// Initial state
const initialState = {
    loading: true,
    overview: null, 
    details: {},
    graphData: null,
    scanStatus: {
        inProgress: false,
        lastScan: null
    },
    download: {
        downloading: false,
        error: null,
        lastDownload: null
    },
    token: {
        value: null,
        generatedAt: null,
        generating: false,
        error: null
    }
};

const quantumReadinessReducer = (state = initialState, action) => {
//export default function (state = initialState, action) {
    //console.log("Quantum reducer called with action:", action.type, action.payload);
    
    switch (action.type) {
        case QUANTUM_OVERVIEW_FETCHED:
            //console.log("Updating overview state with:", action.payload);
            return {
                ...state,
                overview: action.payload,
                loading: false
            };
        case QUANTUM_DETAILS_FETCHED:
            return {
                ...state,
                details: {
                    ...state.details,
                    [action.payload.category]: action.payload.data || action.payload
                },
                loading: false
            };
        case QUANTUM_GRAPH_DATA_FETCHED:
            //console.log("Updating graph data state with:", action.payload);
            return {
                ...state,
                graphData: action.payload,
                loading: false
            };
        // Download cases
        case QUANTUM_DOWNLOAD_START:
            return { 
                ...state, 
                download: { downloading: true, error: null } 
            };
        case QUANTUM_DOWNLOAD_SUCCESS:
            return { 
                ...state, 
                download: { downloading: false, error: null } 
            };
        case QUANTUM_DOWNLOAD_ERROR:
            return { 
                ...state, 
                download: { downloading: false, error: action.payload.error } 
            }; 
        // Token generation
        case QUANTUM_TOKEN_GENERATING:
            return { 
                ...state, 
                token: { 
                    ...state.token, 
                    generating: true,
                    error: null 
                } 
            };
        case QUANTUM_TOKEN_GENERATED:
            return { 
                ...state, 
                token: { 
                    value: action.payload.token,
                    organisationId: action.payload.organisationId,
                    generatedAt: action.payload.generatedAt,
                    generating: false,
                    error: null,
                    valid: true
                } 
            };
        case QUANTUM_TOKEN_ERROR:
            return { 
                ...state, 
                token: { 
                    ...state.token, 
                    generating: false,
                    error: action.payload.error 
                } 
            };
            
        default:
            return state;
    }
};
    
export default quantumReadinessReducer;